// Packages
import { createSlice } from '@reduxjs/toolkit';
// Redux
import {
  getClientLoginsListAsync,
  createClientLoginAsync,
  getClientLoginDetailsAsync,
  updateClientLoginAsync,
  deleteClientLoginAsync,
} from './clientLoginsThunk';
import { clearReducer } from '../auth/authThunk';
// Interfaces and types
import { IGetClientLoginsListRes, IGetClientLoginDetailsRes } from 'types/clientLoginType';
import { IErrorRes } from 'types/appTypes';

interface ISliceClientLoginsState {
  clientLogins: IGetClientLoginsListRes | null;
  clientLoginDetails: IGetClientLoginDetailsRes | null;
  error: IErrorRes | null;
  isLoading: boolean;
}

const initialState: ISliceClientLoginsState = {
  clientLogins: null,
  clientLoginDetails: null,
  error: null,
  isLoading: false,
};

const clientLoginsSlice = createSlice({
  name: 'clientLogins',
  initialState,
  reducers: {
    clearErrors: state => {
      state.error = null;
    },
    resetClientLogins: state => {
      state.clientLogins = null;
      state.clientLoginDetails = null;
    },
  },
  extraReducers: builder => {
    //* GET CLIENT LOGINS ASYNC THUNK
    builder.addCase(getClientLoginsListAsync.pending, state => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getClientLoginsListAsync.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.clientLogins = payload;
    });
    builder.addCase(getClientLoginsListAsync.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload || null;
    });

    //* CREATE CLIENT LOGIN ASYNC THUNK
    builder.addCase(createClientLoginAsync.pending, state => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(createClientLoginAsync.fulfilled, state => {
      state.isLoading = false;
    });
    builder.addCase(createClientLoginAsync.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload || null;
    });

    //* GET CLIENT LOGIN DETAILS ASYNC THUNK
    builder.addCase(getClientLoginDetailsAsync.pending, state => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getClientLoginDetailsAsync.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.clientLoginDetails = payload;
    });
    builder.addCase(getClientLoginDetailsAsync.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload || null;
    });

    //* UPDATE CLIENT LOGIN (one) ASYNC THUNK
    builder.addCase(updateClientLoginAsync.pending, state => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(updateClientLoginAsync.fulfilled, state => {
      state.isLoading = false;
    });
    builder.addCase(updateClientLoginAsync.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload || null;
    });

    //* DELETE CLIENT LOGIN ASYNC THUNK
    builder.addCase(deleteClientLoginAsync.pending, state => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(deleteClientLoginAsync.fulfilled, state => {
      state.isLoading = false;
    });
    builder.addCase(deleteClientLoginAsync.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload || null;
    });

    //* CLEAR REDUCER AFTER SIGN OUT
    builder.addCase(clearReducer, () => initialState);
  },
});

export const { clearErrors, resetClientLogins } = clientLoginsSlice.actions;
export default clientLoginsSlice;
